export function convertMillisecondsToHours(milliseconds) {
    const hourInMilliseconds = 60 * 60 * 1000;
    return Math.floor(milliseconds / hourInMilliseconds);
}
export function convertMillisecondsToHoursWithMinutes(milliseconds) {
    return milliseconds / (1000 * 60 * 60);
}
